import api from './api';

type ArtifactResponse = {
  success: boolean;
  data?: any;
  message?: string;
};

type CreateArtifactPayload = {
  content: string;
  filename: string;
  file_type: string;
  agent_source: string;
  user_id: string;
  session_id: string;
  project_id: string;
  description?: string;
  tags?: string[];
  metadata?: Record<string, any>;
};

function normalizeArtifactResponse(response: any, fallbackMessage: string): ArtifactResponse {
  const data = response?.data ?? response?.artifact ?? response;
  return {
    success: response?.success !== false,
    data,
    message: response?.message || fallbackMessage,
  };
}

export async function createArtifact(payload: CreateArtifactPayload): Promise<ArtifactResponse> {
  try {
    const response = await api.post<{
      success: boolean;
      data?: any;
      message?: string;
    }>('/juben/files/artifacts', payload);
    return normalizeArtifactResponse(response, 'Artifact 已创建');
  } catch (error) {
    console.error('创建 Artifact 失败:', error);
    return { success: false, message: '创建 Artifact 失败' };
  }
}
